import { instance, endpoint, isMockLogin, generator } from 'api'
import { mocker } from 'api/login/mocker'

export default {
  postCurrentUser (username, password) {
    if (isMockLogin) return generator(mocker.currentUser())
    return instance().post(endpoint + '/login/signin', { 'coduser': username, 'codpswd': password })
  },
  postLogout () {
    if (isMockLogin) return generator(mocker.signout())
    return instance().post(endpoint + '/login/signout')
  },
  getBaseConnection () {
    if (isMockLogin) return generator(mocker.baseConn())
    return instance().get(endpoint + '/login/baseConn')
  },
  postForgotPassword (params) {
    if (isMockLogin) return generator(mocker.forgotPassword())
    return instance().post(endpoint + '/login/forgotpassword', params)
  },
  postVerifyOtp (params) {
    if (isMockLogin) return generator(mocker.verifyotp())
    return instance().post(endpoint + '/login/verifyotp', params)
  },
  postChangePassword (params) {
    if (isMockLogin) return generator(mocker.changePassword())
    return instance().post(endpoint + '/login/changepassword', params)
  },
  postAuthVueMiddleware (codapp) {
    if (isMockLogin) return generator(mocker.authVueMiddleware())
    return instance().get(endpoint + '/login/authVueMiddleware/' + codapp)
  },
  postGenEmpImage () {
    return instance().post(endpoint + '/uploader/genEmpImage')
  }
}



// WEBPACK FOOTER //
// ./src/api/login/index.js